import clsx from 'clsx'
import applyBreakpointStyles from './applyBreakpointStyles'

import { IGridProps } from './types'
import styles from './grid.module.scss'

const Grid = ({
  children,
  yAlign,
  xAlign,
  wrap,
  columns,
  spacing,
  xSpacing,
  ySpacing,
  ...props
}: IGridProps) => {
  // This function applies styles for each breakpoint
  const columnsStyles = columns !== undefined ? applyBreakpointStyles(columns, 'grid-columns') : {}
  const alignStyles = yAlign !== undefined ? applyBreakpointStyles(yAlign, 'grid-yAlign') : {}
  const justifyStyles = xAlign !== undefined ? applyBreakpointStyles(xAlign, 'grid-xAlign') : {}
  const wrapStyles = wrap !== undefined ? applyBreakpointStyles(wrap, 'grid-wrap') : {}
  const spacingStylesX =
    spacing !== undefined ? applyBreakpointStyles(spacing, 'grid-xSpacing') : {}
  const spacingStylesY =
    spacing !== undefined ? applyBreakpointStyles(spacing, 'grid-ySpacing') : {}
  const xSpacingStyles =
    xSpacing !== undefined ? applyBreakpointStyles(xSpacing, 'grid-xSpacing') : {}
  const ySpacingStyles =
    ySpacing !== undefined ? applyBreakpointStyles(ySpacing, 'grid-ySpacing') : {}

  return (
    <div
      data-testid="mui-grid"
      style={{
        ...columnsStyles,
        ...alignStyles,
        ...justifyStyles,
        ...wrapStyles,
        ...spacingStylesX,
        ...spacingStylesY,
        ...xSpacingStyles,
        ...ySpacingStyles,
      }}
      {...props}
      className={clsx(styles.gridContainer, props.className)}
    >
      {children}
    </div>
  )
}

export default Grid
